import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConfigService } from 'src/app/service/config.service';
import { RoutingService } from 'src/app/service/routing.service';
import { CustomerApiService } from './customer-api.service';
import { TokenService } from './token.service';

interface EtSessionResponse {
  token: string;
  data_access_token: string;
}

@Injectable({
  providedIn: 'root',
})
export class EtTokenService {
  private static readonly VALIDATE_ENDPOINT = '/v5/validate/jwt';

  constructor(
    private api: CustomerApiService,
    private tokenService: TokenService,
    private routing: RoutingService,
    private config: ConfigService,
  ) {}

  tryAutoLogin(): Observable<boolean> {
    if (this.shouldSkipProbe()) {
      return of(false);
    }
    return this.api
      .post<EtSessionResponse>(EtTokenService.VALIDATE_ENDPOINT, {})
      .pipe(
        tap((response) => {
          this.tokenService.etTokenProbed = true;
          if (response?.token) {
            this.tokenService.setTokens(
              response.token,
              response.data_access_token,
            );
          }
        }),
        map((response) => Boolean(response?.token)),
        catchError(() => {
          this.tokenService.etTokenProbed = true;
          return of(false);
        }),
      );
  }

  private shouldSkipProbe(): boolean {
    if (!this.config.appConfig?.setup?.enableEmployeeAuthToken) return true;
    if (this.tokenService.etTokenProbed) return true;
    if (this.tokenService.getActiveToken()) return true;
    if (this.routing.isReader() || this.routing.isStoryReader()) {
      return true;
    }
    return false;
  }
}
